<div class="card" [ngClass]="styleClass()">
  @if (title()) {
    <h3 class="card__title">{{ title() | transloco }}</h3>
  }
  @if (subtitle()) {
    <p class="card__subtitle">{{ subtitle() | transloco }}</p>
  }
  <div class="card__body">
    <ng-content></ng-content>
  </div>
</div>
